import { render, staticRenderFns } from "./djg-edit.vue?vue&type=template&id=ddf51e84&scoped=true&"
import script from "./djg-edit.vue?vue&type=script&lang=js&"
export * from "./djg-edit.vue?vue&type=script&lang=js&"
import style0 from "./djg-edit.vue?vue&type=style&index=0&id=ddf51e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf51e84",
  null
  
)

export default component.exports